import { GAME, GAME_STATUS } from '../config.js';

export function createInitialState(duration = GAME.DEFAULT_DURATION, useDurationLimit = false) {
    return {
        status: GAME_STATUS.IDLE,
        score: 0,
        lives: GAME.INITIAL_LIVES,
        timeLeft: useDurationLimit ? duration : 0,
        duration,
        useDurationLimit,
        items: [],
        outcome: null,
        breakdown: {
            leads: 0,
            goodLeads: 0,
            hotLeads: 0,
            activities: 0,
            bonus: 0,
            penalties: 0,
            timeSeconds: 0,
        },
        stats: {
            leadsCaught: 0,
            goodHits: 0,
            hotHits: 0,
            activityHits: 0,
            bonusHits: 0,
            badHits: 0,
            missedGoodLeads: 0,
        },
    };
}

/** @param {number} timeSeconds Elapsed play time in seconds. */
export function buildResult(state, outcome, timeSeconds) {
    const timeElapsed = Math.max(0, Math.round(timeSeconds));

    return {
        outcome,
        score: state.score,
        breakdown: {
            ...state.breakdown,
            timeSeconds: timeElapsed,
        },
        stats: { ...state.stats },
        timeElapsed,
    };
}
